import {useParams} from 'react-router-dom'
import React from 'react';

import {CRReviewTerrainCom} from '../containers'
function CRReviewTerrainComPage() {
    console.log('shsohourn to star')
    let { id } = useParams();
    let svparams = { 'id': id}
    console.log('shsohourn to svparams 3', svparams)
    return (
        <CRReviewTerrainCom svparams= {svparams} />
    );
}
export default CRReviewTerrainComPage

/*
import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVReviewTerrainCom} from '../containers'
function CRReviewTerrainComPage() {
    let { id } = useParams();
    let svparams = { 'id': id}
    return (
        <div>

        <p>
          SV SojournReviewContainerPage Component
        </p>
        <SVReviewTerrainCom svparams= {svparams} />
        </div>
    );
}
export default CRReviewTerrainComPage
*/